module.exports = __webpack_public_path__ + "static/ESGHeader-e323f9bf44aebffae572bc245bd5d6b4.jpg";